export default "https://fiverr-res.cloudinary.com/npm-assets/@fiverr/search_perseus/ms_sql.56b7f9c.svg";